import AdminLayout from "../../../components/admin/layout/AdminLayout";
import { useLocation } from "react-router-dom";
import SurveySingleView from "../../../components/common/survey/SurveySingleView";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveySingleViewPage() {
  const { userType } = useAuthStore();
  const location = useLocation();
  const surveyID = location.state || {};

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <SurveySingleView surveyID={surveyID} />
    </AdminLayout>
  );
}

export default SurveySingleViewPage;
